<div class="panel">
    <div class="dashboard">
        <app-dashboard [usuarioPanel]="usuarioPanel"></app-dashboard>
    </div>
    <div class="panelContent">  
        <app-header-panel [usuarioPanel]="usuarioPanel"></app-header-panel>
        <app-obra-social-form [editar]="editar" [obraSocial]="obraSocial"></app-obra-social-form>
    </div>  
</div>